module.exports = __webpack_public_path__ + "static/media/06-speaker_profile.064a45e2.webp";